import { Injectable, signal } from '@angular/core';

export interface TransitionOverlayConfig {
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class TransitionOverlayService {
  private _visible = signal(false);
  private _isLeaving = signal(false);
  private _message = signal('Cargando...');

  /** Reactive state consumed by the global overlay component */
  readonly visible = this._visible.asReadonly();
  readonly isLeaving = this._isLeaving.asReadonly();
  readonly message = this._message.asReadonly();

  show(config?: TransitionOverlayConfig): void {
    this._message.set(config?.message ?? 'Cargando...');
    this._isLeaving.set(false);
    this._visible.set(true);
  }

  /**
   * Hide the overlay with a smooth fade-out animation.
   * First waits for the destination component to paint (paintDelayMs),
   * then triggers the fade-out CSS class (takes 300ms), and finally
   * removes the element from DOM.
   */
  hide(paintDelayMs = 200): void {
    // 1. Dar tiempo al navegador para pintar el nuevo layout
    setTimeout(() => {
      this._isLeaving.set(true);
      
      // 2. Esperar a que termine la animación CSS de fade-out (300ms) para remover del DOM
      setTimeout(() => {
        this._visible.set(false);
        this._isLeaving.set(false);
      }, 300);
    }, paintDelayMs);
  }

  /**
   * Show the overlay and immediately execute the navigation action.
   * The overlay stays up until the destination calls hide().
   */
  showAndNavigate(action: () => void, config?: TransitionOverlayConfig): void {
    this.show(config);
    // Un tick rápido para asegurar que el overlay se renderice antes de la destrucción de la ruta anterior
    setTimeout(() => action(), 80);
  }
}
